export enum MapMultiMarker {
  SourceId = 'multi-markers',
  PointId = 'multi-marker-point',
  LabelId = 'multi-marker-label',
}
